import React from 'react';
import { GalleryHeaderProps } from '../types';
import classes from './galleryHeader.module.scss';

const GalleryHeader: React.FC<GalleryHeaderProps> = ({ content }) => {
  const {
    galleryHeader,
    typography,
    imageGrid,
    teaserImage,
    xVector,
    halfOVector,
    relativeContainer,
  } = classes;

  return (
    <div className={`responsiveGridLayout ${relativeContainer}`} style={{ backgroundColor: content.backgroundColor }}>
      <img src="/x-vector.png" className={xVector} alt='vector' />
      <img src="/half-o-vector.svg" className={halfOVector} alt='vector' />
      <div className={`${galleryHeader} responsiveMainContent`} style={{ color: content.headerTxtColor }} >
          <div className={typography}>
              <span>{content.name}</span>
              <h1>{content.headline}</h1>
              <p>{content.text}</p>
          </div>
          <div className={imageGrid}>
            <img src={`/${content.imageName}.png`} className={teaserImage} alt="verticalImage" />
          </div>
      </div>
    </div>
  );
};

export default GalleryHeader;
